var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vf-tabs"},[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"2D","name":"2D"}}),_c('el-tab-pane',{attrs:{"label":"3D","name":"3D"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }